import {createApp} from 'vue'

import App from './App.vue'
import router from './router'

import Vant from 'vant';
import 'vant/lib/index.css';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlay, faBackward, faForward,faPause,faReply,faShare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faPlay)
library.add(faBackward)
library.add(faForward)
library.add(faPause)
library.add(faReply)
library.add(faShare)


const app = createApp(App)

app.config.globalProperties.$title = '数字资源推广特色数据库'
app.config.unwrapInjectedRef = true

app.use(router)
app.use(Vant)

app.component("font-awesome-icon", FontAwesomeIcon)

app.mount('#app')
